var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"separation-anxiety"},[_c('separation-anxiety-card'),_c('separation-anxiety-mission-possible-card'),_c('separation-anxiety-do-it-yourself-card')],1)}
var staticRenderFns = []

export { render, staticRenderFns }